import React from 'react';
import { formatCurrency } from '../../services/api';

const PanelGraficosAnalisis = ({ informe, analisis }) => {
  const { statsGraficos } = informe || {};
  const { resumen } = analisis || {};

  if (!statsGraficos) return null;

  const totalPago = statsGraficos.pagados + statsGraficos.pendientes;
  const pctPagado = totalPago > 0 ? (statsGraficos.pagados / totalPago) * 100 : 0;
  const pctPend = totalPago > 0 ? 100 - pctPagado : 0;

  const maxVendido = Math.max(...statsGraficos.porServicio.map((s) => s.vendido), 1);

  return (
    <div className="tma-graficos">
      <div className="tma-graficos-grid">
        <div className="tma-grafico-card">
          <div className="tma-grafico-titulo">Estado de cobro</div>
          <div className="tma-donut-legend">
            <div className="tma-donut-bar">
              <div className="tma-donut-seg tma-donut-seg--ok" style={{ width: `${pctPagado}%` }} />
              <div className="tma-donut-seg tma-donut-seg--due" style={{ width: `${pctPend}%` }} />
            </div>
            <div className="tma-donut-labels">
              <span><i className="tma-dot tma-dot--ok" /> Pagado ({statsGraficos.pagados})</span>
              <span><i className="tma-dot tma-dot--due" /> Pendiente ({statsGraficos.pendientes})</span>
            </div>
          </div>
        </div>

        <div className="tma-grafico-card">
          <div className="tma-grafico-titulo">Entregas</div>
          <div className="tma-donut-legend">
            <div className="tma-donut-bar">
              <div className="tma-donut-seg tma-donut-seg--accent" style={{
                width: `${analisis.total > 0 ? (statsGraficos.entregados / analisis.total) * 100 : 0}%`
              }} />
              <div className="tma-donut-seg tma-donut-seg--muted" style={{
                width: `${analisis.total > 0 ? (statsGraficos.enCurso / analisis.total) * 100 : 0}%`
              }} />
            </div>
            <div className="tma-donut-labels">
              <span><i className="tma-dot tma-dot--accent" /> Entregados ({statsGraficos.entregados})</span>
              <span><i className="tma-dot tma-dot--muted" /> En curso ({statsGraficos.enCurso})</span>
            </div>
          </div>
          {resumen?.vencidos > 0 && (
            <div className="tma-grafico-alerta">{resumen.vencidos} vencido{resumen.vencidos === 1 ? '' : 's'}</div>
          )}
        </div>
      </div>

      {statsGraficos.porServicio.length > 0 && (
        <div className="tma-grafico-card tma-grafico-card--wide">
          <div className="tma-grafico-titulo">Ingreso vendido por servicio</div>
          <div className="tma-bars">
            {statsGraficos.porServicio.map((s) => (
              <div key={s.nombre} className="tma-bar-row">
                <span className="tma-bar-label" title={s.nombre}>{s.nombre}</span>
                <div className="tma-bar-track">
                  <div
                    className="tma-bar-fill"
                    style={{ width: `${(s.vendido / maxVendido) * 100}%` }}
                  />
                </div>
                <span className="tma-bar-val">{formatCurrency(s.vendido)}</span>
                <span className="tma-bar-pct">{s.pctCobrado}% cob.</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default PanelGraficosAnalisis;
